
<script setup>

  import { ref } from 'vue';

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import AudioPlayer from '../components/audio-player.vue';

  import SimpleDialog from '../dialogs/simple.vue';

  import ParallaxLayer from '../components/parallax-layer.vue';

  import { selectedResponse } from '../stores/activity-2.js';

  import backgroundPath from '../images/rough-background.jpg';

  import layerPaths from '../images/activity-2-part-6-layer-*.png';

  import audio_s1e7_2140_2312 from '../audio/s1e7_2140_2312.mp3';

  import track_s1e7_2140_2312 from '../audio/s1e7_2140_2312.vtt';

  const layers = Object.values( layerPaths );

  const stayDialog = ref( null );

  const leaveDialog = ref( null );

  selectedResponse.value = null;

</script>

<template>

  <article class="bg-white">

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <ParallaxLayer v-for="( path, index ) in layers" :z="30 - index * 10" class="row-start-1 col-start-1 w-screen h-full">

        <img :src="path" alt="" aria-hidden="true" class="w-full h-full object-cover scale-110 transition-[opacity,filter] grayscale opacity-10 xl:grayscale-0 xl:opacity-100" />

      </ParallaxLayer>

      <div class="row-start-1 col-start-1 relative p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h3 class="text-5xl font-heading uppercase">

            As you're beginning to relax

          </h3>

          <p class="mt-8 text-neutral-700">

            ...and enjoy your picnic, your son tugs at your sleeve.

            "I need to go to the bathroom."

            You take him to the comfort station on the other side of the picnic ground &mdash; the side toward the white visitors.

          </p>

          <p class="mt-8 text-neutral-700">

            He washes his hands and as the two of you head back to your table, you overhear a woman yelling at a ranger.

            She's pointing at you and your family.

          </p>

          <div class="mt-8">

            <AudioPlayer :src="audio_s1e7_2140_2312" :track="track_s1e7_2140_2312" />
          
            <div class="mt-3 text-xs italic">Source: Driving the Green Book - Macmillan Podcasts - S1:E7</div>

          </div>

          <p class="mt-8 text-2xl font-semibold font-serif italic">What do you do?</p>

          <div class="md:flex items-center gap-6 mt-8">

            <button type="button" @click="event => { selectedResponse = 'stay'; stayDialog.open() }"
            
              class="block px-6 py-4 font-bold bg-amber-300 transition-colors
              
              hover:bg-amber-400 focus-visible:bg-amber-400 hover:underline focus-visible:underline">

              <div>Stay at the picnic area.</div>

            </button>

            <div class="hidden md:block">Or</div>

            <button type="button" @click="event => { selectedResponse = 'leave'; leaveDialog.open() }"
            
              class="block mt-6 md:mt-0 px-6 py-4 font-bold text-white bg-green-700 transition-colors
              
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline">

              <div>Pack up and leave.</div>

            </button>

          </div>

        </div>

      </div>

    </div>

    <SimpleDialog ref="stayDialog" title="Stay at the picnic area." class="max-w-2xl">

      <img src="../images/activity-2-part-6-stay.jpg" alt="A park ranger standing in front of a patrol pickup truck in Shenandoah National Park." />

      <p class="mt-6 text-neutral-700">

        The ranger calms the lady down.

        You quickly finish your picnic and continue south to Lewis Mountain.

      </p>

      <div class="flex justify-end mt-6">

        <RouterLink
        
          class="flex items-center gap-4 px-6 py-4 font-bold text-white bg-green-700 transition-colors
          
            hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
        
          to="/activity/2/part/7">

          <span>Continue</span>

          <ArrowRightCircleIcon class="w-8" />

        </RouterLink>

      </div>

    </SimpleDialog>

    <SimpleDialog ref="leaveDialog" title="Pack up and leave." class="max-w-2xl">

      <img src="../images/activity-2-part-6-leave.jpg" alt="An empty Skyline Drive winding through the woods of Shenandoah National Park." />

      <p class="mt-6 text-neutral-700">

        You don't want to cause any trouble, so you pack up your picnic and continue south to Lewis Mountain.

      </p>

      <div class="flex justify-end mt-6">

        <RouterLink
        
          class="flex items-center gap-4 px-6 py-4 font-bold text-white bg-green-700 transition-colors
          
            hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
        
          to="/activity/2/part/7">

          <span>Continue</span>

          <ArrowRightCircleIcon class="w-8" />

        </RouterLink>

      </div>

    </SimpleDialog>

  </article>

</template>
